var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"icon-action",attrs:{"small":"","color":"#013767","disabled":!_vm.canRead},on:{"click":function($event){return _vm.goToDetail(_vm.item)}}},[_vm._v("mdi-pencil")])}
var staticRenderFns = []

export { render, staticRenderFns }